var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 11.6667L6.24984 9.25008C6.38573 8.9802 6.59244 8.75233 6.84785 8.59087C7.10325 8.42941 7.39775 8.34041 7.69984 8.33341H16.6665M16.6665 8.33341C16.9211 8.33297 17.1724 8.39086 17.4012 8.50265C17.63 8.61444 17.8301 8.77715 17.9861 8.9783C18.1422 9.17945 18.2502 9.41369 18.3017 9.66304C18.3531 9.91239 18.3468 10.1702 18.2832 10.4167L16.9998 15.4167C16.907 15.7764 16.6967 16.0947 16.4023 16.3212C16.1079 16.5476 15.7463 16.6693 15.3748 16.6667H3.33317C2.89114 16.6667 2.46722 16.4912 2.15466 16.1786C1.8421 15.866 1.6665 15.4421 1.6665 15.0001V4.16675C1.6665 3.72472 1.8421 3.3008 2.15466 2.98824C2.46722 2.67567 2.89114 2.50008 3.33317 2.50008H6.58317C6.86191 2.49735 7.13688 2.56457 7.38292 2.6956C7.62896 2.82662 7.8382 3.01727 7.9915 3.25008L8.6665 4.25008C8.81826 4.48052 9.02486 4.66968 9.26775 4.80058C9.51065 4.93149 9.78225 5.00003 10.0582 5.00008H14.9998C15.4419 5.00008 15.8658 5.17567 16.1783 5.48824C16.4909 5.8008 16.6665 6.22472 16.6665 6.66675V8.33341Z",
    stroke: "#2563EB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projects_icon.fa2b297dcddd1f9b712992079987bffa.svg";
export { ForwardRef as ReactComponent };